import gql from 'graphql-tag';

export const markAsReadMutation = gql`
    mutation markAsRead($memoId: ID!) {
        markAsRead(id: $memoId) {
            id
        }
    }`;
